export const stringSearch = /^(?=.*?[a-z]).{1,}$/;
export const siretSearch = /^(?=.*?[0-9]).{5,14}$/;
export const siretValid = /^(?=.*?[0-9]).{14}$/;
export const siretInvalid = /^(?=.*?[0-9]).{15,}$/;
